import React, { useEffect } from 'react';

const addLibScript = (src?: string): void => {
  const scriptSrc = src || '//s3.amazonaws.com/ki.js/61846/e4g.js';
  const script = document.createElement('script');
  script.async = true;

  script.innerHTML = `
    var _kiq = _kiq || [];
    (function(){
      setTimeout(function(){
      var d = document, 
      f = d.getElementsByTagName('script')[0], 
      s = d.createElement('script'); 
      s.type = 'text/javascript';
      s.async = true; s.src = '${scriptSrc}'; 
      f.parentNode.insertBefore(s, f);
      }, 1);
    })();
  `;

  document.body.appendChild(script);
};

const addPropertiesScript = (properties?: any): void => {
  if (!properties) {
    return;
  }

  const script = document.createElement('script');
  script.innerHTML = `_kiq.push(['set', ${JSON.stringify(properties)}]);`;
  document.body.appendChild(script);
};

const addIdentifierScript = (identifier?: string): void => {
  if (!identifier) {
    return;
  }

  const script = document.createElement('script');
  script.innerHTML = `_kiq.push(['identify', '${identifier}']);`;
  document.body.appendChild(script);
};

interface Props {
  src?: string;
  properties?: any;
  identifier?: string;
}

export const Qualaroo: React.FC<Props> = ({ src, properties, identifier }) => {
  useEffect(() => {
    addLibScript(src);
    addPropertiesScript(properties);
    addIdentifierScript(identifier);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
